import * as z from "zod";
import { runSummarySchema } from "./common";

/** An automation's runs, newest first. */
export const listRuns = {
  name: "listRuns" as const,
  input: z.object({
    id: z.string(),
    limit: z.number().int().positive().max(200).optional(),
  }),
  output: z.object({ runs: z.array(runSummarySchema) }),
};
